import { useOrdersFilter } from "@usher/pe-client-front-end-lib"
import { FilterBase } from "./FilterBase"

type Props = {
  onFilter: (filter: any) => void
  type?: "Sell" | "Buy" | "Card" | "IBAN"
  withoutExchangeTo?: boolean
  compact?: boolean
}

export const ExchangeFilter = ({ withoutExchangeTo = false, compact = false, onFilter, type = "Buy" }: Props) => {
  const { options, onReset, onSubmit, formMethods } = useOrdersFilter({
    onFilter,
    type,
    compact,
  })

  return (
    <FilterBase
      // @ts-expect-error
      formMethods={formMethods}
      type={type}
      onReset={onReset}
      onSubmit={onSubmit}
      // @ts-expect-error
      options={options}
      withoutExchangeTo={withoutExchangeTo}
    />
  )
}
